// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"213":"c6658172","541":"c6658172","842":"c6658172"}[chunkId] + ".chunk.css";
};